const typeTemplate = (data = {}) => ({
    accessibility: data.accessibility,
    active: data.active,
    appointmentRule: data.appointmentRule, // ToDo: Map template
    bookingCount: data.bookingCount,
    calendarUserId: data.calendarUserId,
    duration: data.duration,
    id: data.id,
    location: data.location,
    schoolId: data.schoolId,
    title: data.title,
    start: data.start,
    end: data.end,
    description: data.description || '',
});

const availabilityTemplate = (data = {}) => ({
    id: data.elementToken,
    element_token: data.elementToken,
    members: data.members,
});

const eventTemplate = (data = {}) => ({
    id: data.id,
    start_time: data.start_time,
    end_time: data.end_time,
    appointmentTypeId: data.appointment_type_id,
    sub: data.sub,
    status: data.status,
});

const userinfoTemplate = (data = {}) => ({
    id: data.id,
    userId: data.userId,
    sub: data.sub,
    email: data.email,
});

export default {
    baseURL: process.env.VUE_APP_API_URL.concat('v1/'),
    template: ['CALENDAR_TEMPLATE', data => data],
    authorize: true,
    '/type': {
        template: ['CALENDAR_TYPE_TEMPLATE', data => ({ id: 1, ...data })],
        authorize: true,
        GET: {},

        '/:id': {
            template: ['CALENDAR_TYPE_TEMPLATE', typeTemplate],
            GET: {},
        },
    },
    '/availability': {
        template: ['CALENDAR_AVAILABILITY_TEMPLATE', availabilityTemplate],
        authorize: true,
        GET: {},
    },
    '/event': {
        template: ['CALENDAR_EVENT_TEMPLATE', eventTemplate],
        authorize: true,
        POST: {},
        GET: {},

        '/:id': {
            '/cancel': {
                authorize: true,
                POST: {},
            },
        },
    },
    '/userinfo': {
        template: ['CALENDAR_USER_INFO', userinfoTemplate],
        authorize: true,
        GET: {},
    },
};
